import {Output, Color, FileType, ChangeFunction} from '../../types';
import {SettingsPanel, ToggleGroup, Option, useValue} from '@esgi/main/kits/reports';

interface Props {
	disabled?: boolean;
	onChange: ChangeFunction<Output>;
}

const displays: Option[] = [
	{id: Color.Сolourful, label: 'Color'},
	{id: Color.BlackAndWhite, label: 'Black & White'},
];

const types: Option[] = [
	{id: FileType.Pdf, label: 'PDF File', description: 'Per student or class'},
	{id: FileType.Zip, label: 'ZIP Archive', description: 'Individual PDF files for each student in the class'},
];

export function OutputControl({disabled, onChange}: Props) {
	const [value, setValue] = useValue<Output>({
		color: Color.Сolourful,
		fileType: FileType.Pdf,
	}, onChange);

	return (
		<SettingsPanel title='Output'>
			<ToggleGroup
				value={value.color.toString()}
				options={displays}
				disabled={disabled}
				onChange={(color) => setValue({...value, color: color as Color})}
			/>
			<ToggleGroup
				value={value.fileType.toString()}
				options={types}
				disabled={disabled}
				onChange={(fileType) => setValue({...value, fileType: fileType as FileType})}
			/>
		</SettingsPanel>
	);
}
